<!--
  SILL-1533 (CUEST02.2) — Vista privada de las respuestas del cuestionario de
  falla, desde el detalle de la OT en Center, con el diseño de CUEST02.1
  (SILL-1532) aplicado.

  Las respuestas de texto libre se muestran completas, sin truncar: el modal
  tiene scroll vertical propio, y el largo ya viene acotado desde el formulario
  público (2000 caracteres, `MAX_LARGO_RESPUESTA_TEXTO` en el backend).
-->
<template lang="pug">
  span
    b-button.ff-boton.no-print(variant="warning" @click="abrir")
      font-awesome-icon.mr-2(icon="file-alt")
      | Ver Cuestionario del Cliente
    //- `scrollable` deja fijos el encabezado y el pie, y hace que sólo scrollee
    //- la lista de respuestas (nota de diseño: scroll vertical en el modal).
    b-modal(
      v-model="showModal"
      size="lg"
      centered
      scrollable
      dialog-class="ff-modal"
      header-class="ff-modal__cabecera"
      body-class="ff-modal__cuerpo"
      footer-class="ff-modal__pie"
    )
      template(#modal-header)
        div
          h2.ff-modal__titulo Cuestionario de falla computador ASUS
          p.ff-modal__ot OT: {{ otId }}
        button.ff-modal__cerrar(type="button" aria-label="Cerrar" @click="showModal = false")
          font-awesome-icon(icon="times")

      .text-center.py-4(v-if="loading")
        b-spinner(label="Cargando")
      b-alert(v-else-if="error" show variant="warning") {{ error }}
      b-alert(v-else-if="!respuestas.length" show variant="light")
        | El formulario no tiene respuestas registradas.
      ol.ff-respuestas(v-else)
        li.ff-respuesta(v-for="(respuesta, indice) in respuestas" :key="respuesta.id")
          .ff-respuesta__pregunta
            span.ff-respuesta__numero {{ indice + 1 }}.
            span {{ respuesta.pregunta_texto }}
          ul.ff-respuesta__lista(v-if="esSeleccion(respuesta)")
            li(v-for="(valor, i) in comoLista(respuesta.valor)" :key="i") {{ valor }}
          p.ff-respuesta__texto(v-else) {{ respuesta.valor }}

      template(#modal-footer)
        b-button.ff-modal__boton-cerrar(@click="showModal = false") Cerrar
</template>

<script>
import { obtenerRespuestasOT } from '@/services/formularioFallaService'

export default {
  name: 'FormularioFallaRespuestas',
  props: {
    otId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      loading: false,
      error: null,
      respuestas: [],
      completadoEn: null,
    }
  },
  methods: {
    abrir() {
      this.showModal = true
      if (this.respuestas.length || this.loading) return
      this.cargar()
    },
    cargar() {
      this.loading = true
      this.error = null
      return obtenerRespuestasOT(this.otId)
        .then((data) => {
          this.respuestas = data.respuestas || []
          this.completadoEn = data.completado_en
        })
        .catch(() => {
          this.error = 'No pudimos cargar las respuestas del cuestionario.'
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** Las de selección se listan con viñetas; el texto libre va como párrafo. */
    esSeleccion(respuesta) {
      return respuesta.tipo === 'RADIO' || respuesta.tipo === 'CHECK'
    },
    comoLista(valor) {
      return Array.isArray(valor) ? valor : [valor]
    },
  },
}
</script>

<style>
/* Sin `scoped`: b-modal monta el diálogo fuera de este componente, así que los
   estilos del modal no pueden depender del atributo de scope. */
.ff-modal .modal-content {
  border: none;
  border-radius: 12px;
}

.ff-modal .ff-modal__cabecera {
  border-bottom: none;
  align-items: flex-start;
  padding: 24px 28px 12px;
}

/* Los `!important` no son capricho: el proyecto tiene overrides globales
   `.modal-body { padding: .2rem 1rem !important }` y
   `.modal-footer { justify-content: flex-start !important }` que si no ganan
   ellos. Van acotados a `.ff-modal`, así que no tocan los demás modales. */
.ff-modal .ff-modal__cuerpo {
  padding: 0 28px !important;
}

.ff-modal .ff-modal__pie {
  border-top: none;
  justify-content: center !important;
  padding: 20px 28px 24px;
}
</style>

<style scoped>
.ff-boton {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  color: #23201c;
  border-radius: 8px;
  padding: 10px 16px;
  border: none;
}

.ff-modal__titulo {
  font-size: 20px;
  font-weight: 700;
  color: #23201c;
  margin: 0 0 2px;
  line-height: 1.25;
}

.ff-modal__ot {
  font-size: 15px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

.ff-modal__cerrar {
  background: none;
  border: none;
  padding: 0;
  font-size: 20px;
  line-height: 1;
  color: #23201c;
  cursor: pointer;
}

.ff-respuestas {
  list-style: none;
  margin: 0;
  padding: 0;
}

.ff-respuesta {
  margin-bottom: 20px;
}

.ff-respuesta:last-child {
  margin-bottom: 0;
}

.ff-respuesta__pregunta {
  display: flex;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #23201c;
  line-height: 1.35;
  margin-bottom: 6px;
}

.ff-respuesta__numero {
  flex-shrink: 0;
}

.ff-respuesta__lista {
  margin: 0;
  padding-left: 34px;
  /* Anidada dentro del <ol> de preguntas, el navegador usaría viñeta hueca. */
  list-style-type: disc;
  font-size: 14px;
  color: #23201c;
  line-height: 1.5;
}

.ff-respuesta__texto {
  margin: 0;
  padding-left: 22px;
  font-size: 14px;
  color: #23201c;
  line-height: 1.5;
  /* Texto libre completo: respeta los saltos de línea del cliente y corta las
     palabras larguísimas en vez de desbordar el modal. */
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.ff-modal__boton-cerrar {
  background: #f0f0f0;
  border: none;
  color: #23201c;
  font-size: 15px;
  font-weight: 400;
  border-radius: 8px;
  padding: 8px 28px;
}

.ff-modal__boton-cerrar:hover {
  background: #e2e2e2;
  color: #23201c;
}
</style>
